import React from 'react';
import './VideoComp.css';

interface VideoCompProps {
  id: string;
  title: string;
  heading: string;
  description: string;
  video?: string; 
  image?: string; 
}

const VideoComp: React.FC<VideoCompProps> = ({
  id,
  title,
  heading,
  description,
  video,
  image,
}) => {
  return (
   <section className={`bifurcated-video-section ${id}`} id={id}>

      <div className="video-text">
        <h3>{title}</h3>
        <h1>{heading}</h1>
        <p>{description}</p>
      </div>
      <div className="video-content">
        {video ? (
          <video
            className="promo-video"
            src={video}
            autoPlay
            muted
            loop
            playsInline
          />
        ) : image ? (
          <img className="promo-video" src={image} alt="promo" />
        ) : null}
      </div>
    </section>
  );
};

export default VideoComp;
